/* eslint-disable react/no-unknown-property */
/* eslint-disable react/self-closing-comp */
import { Box, Typography, useTheme } from '@mui/material'
import { formatSize } from './utils'
import { FileProps } from './types'
import { ExcelIcon, PdfIcon, ImageFileIcon, GenericFileIcon } from './Icons'

type EstimateFileItemProps = {
  file: FileProps
  handleDlFile: (fileId: FileProps['id']) => void
}

const fileIconMap = {
  '.png': ImageFileIcon,
  '.jpg': ImageFileIcon,
  '.jpeg': ImageFileIcon,
  '.ico': ImageFileIcon,
  '.tiff': ImageFileIcon,
  '.icon': ImageFileIcon,
  '.pdf': PdfIcon,
  '.xlsx': ExcelIcon,
  '.xls': ExcelIcon,
  '.csv': ExcelIcon,
}

const EstimateFileItem = ({ file, handleDlFile }: EstimateFileItemProps) => {
  const FileIcon =
    fileIconMap[file?.type as keyof typeof fileIconMap] || GenericFileIcon
  const theme = useTheme()

  return (
    <Box
      gap={1}
      sx={{
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <Box
        gap={2}
        sx={{
          display: 'flex',
          alignItems: 'center',
          width: '100%',
          color: (theme) => theme.palette.primary.main || '#00ADE6',
          fontSize: '12px',
          ':hover': {
            color: (theme) => theme.palette.primary.main || '#00ADE6',
            '.file-item-subject': {
              color: '#041725 !important',
            },
          },
        }}
      >
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: '6px',
            cursor: 'pointer',
          }}
          onClick={() => handleDlFile(file?.id)}
        >
          <FileIcon
            width="12px"
            height="18px"
            color={theme.palette.primary.main || '#00ADE6'}
          />
          <Typography fontWeight={500}>{file.name}</Typography>
        </Box>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <Typography sx={{ color: '#969696' }}>
            {formatSize(file?.size || 0)}
          </Typography>
        </Box>
      </Box>
      <Typography
        component="span"
        variant="body2"
        fontSize="12px"
        className="file-item-subject"
      >
        {file?.subject || ''}
      </Typography>
    </Box>
  )
}

export default EstimateFileItem
